import { TYPE_LIST, LEAD_GATE, ADD_APARTMENT_GATE, ADD_CORPORATE_GATE } from "./type";

const initalState = {
  typeList: [],
  gateData: {},
  leadGates: {},
};

const gateReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPE_LIST:
      return {
        ...state,
        typeList: payload,
      }
      case LEAD_GATE:
      return {
        ...state,
        leadGates: payload,
        
      };
      case ADD_APARTMENT_GATE:
      return {
        ...state,
        gateData: payload
      }
      case ADD_CORPORATE_GATE:
        return {
          ...state,
          gateData: payload
        }
    default:
      return {
        ...state,
      };
  }
};

export default gateReducer;
